import TurtleIcon from "images/Turtle.icon";

const umd_red = {
	50: "#fce3e7",
	100: "#f6bac2",
	200: "#f18c99",
	300: "#eb5d70",
	400: "#e63b52",
	500: "#118ab2",
	600: "#df152e",
	700: "#da1127",
	800: "#d60e20",
	900: "#cf0814",
	A100: "#fff8f8",
	A200: "#ffc5c8",
	A400: "#ff9297",
	A700: "#ff797e",
	contrastDefaultColor: "light",
};
const brand = umd_red;

const config = {
	brand,
	name: "Tracking Working Time",
	apiUrl: process.env.REACT_APP_API_URL || "/api",
	basename: process.env.REACT_APP_BASENAME || "/",
	documentationURL: "https://terpfootprints.umd.edu/docs",
	contact: {
		email: "city@umd.edu",
		name: "City@UMD",
	},
	surveyURL:
		"https://docs.google.com/forms/d/e/1FAIpQLSehPFILRbfuQ2mam7vxZEinZ1EFdwW-gP70k6t_EI7zbz01sw/viewform",
	loadingIcon: TurtleIcon,
	organization: {
		name: "BuildSci Inc",
		location: "College Park, MD",
		nameShort: "UMD",
		type: "Campus",
		orgIcon: "account_balance",
		logoBanner: "images/logos/umd_logo.png",
		logo: "images/logos/umd_icon_logo.png",
		reportLogo: "images/logos/umd_globe.png",
		orgImage: "images/logos/umd_campus.jpg",
		fiscalYearMonthStart: 6,
	},
	department: {
		leader: "Director",
		name: "Facilities Management: Engineering & Energy",
		leaderImage: "images/reports/director.png",
		groupImage: "images/reports/FM_DepartmentLogo.png",
		address: `7757 Baltimore Ave. College Park, MD 20742`,
		contact: { phone: "301-405-2222", email: "fmcrc@umd.edu" },
	},
	auth: {
		thirdPartyLogin: true,
		thirdPartyLoginName: "UMD ID",
		thirdPartyApiPath: "/auth/umd-login",
		thirdPartyLoginPath: () =>
			`https://shib.idm.umd.edu/shibboleth-idp/profile/cas/login?service=${encodeURIComponent(
				window.location.origin + window.location.pathname
			)}`,
		levels: [
			{ id: "public", label: "Public Users" },
			{ id: "general", label: "General Users" },
			{ id: "advanced", label: "Advanced Users" },
			{
				id: "facilities",
				label: "Facility Management Users",
			},
			{ id: "admin", label: "Admin Users" },
			{ id: "dev", label: "Admin Users" },
		],
	},
	map: {
		defaultCenter: [-76.96225948, 38.97420956],
		icon: TurtleIcon,
		// icon: "building-15",
		// iconPath: "/images/icons"
		// mapIconPath: "/images/icons",
		// mapIcon: "building-15"
	},
	baselineYear: new Date(2015, 0),
	host: {
		logo: "/images/host/icon.png",
	},
	userAnalytics: {
		datastudio: {
			iframe: `<iframe id='datastudio' width="800" height="400" src="https://datastudio.google.com/embed/reporting/791add56-bc79-440c-8f8b-79b6cdb60044/page/hnwkB" frameborder="0" style="border:0"/>`,
			link:
				"https://datastudio.google.com/embed/reporting/791add56-bc79-440c-8f8b-79b6cdb60044/page/hnwkB",
		},
	},
	cookieConsent: {
		name: "cookieconsent_status_umd",
		path: "/",
		domain: "buildscianalyst.com",
		expiryDays: 356,
		secure: true,

		header: 'Cookies used on the website!',
		message: 'This website uses cookies to improve your experience and make web application fully operational.',
		dismiss: 'Got it!',
		allow: 'Allow cookies',
		deny: 'Decline',
		link: 'Learn more',
		href: 'https://www.allaboutcookies.org',
		hrefDeny: 'https://buildsci.com/',
		close: '&#x274c;',
		policy: 'Cookie Policy',
		target: '_blank',
	},
};

document.title = config.name;
export default config;
